export default {
  API_HOST: "https://appservice.u-city.com.tw/",
  // API_HOST: "https://ucity-api-test.shoppalz.com/",
  // API_HOST: "http://192.168.31.211:5001/",
};



// WEBPACK FOOTER //
// ./src/config.js